'use strict';
import template from './operacionesCorte.html';
import controller from './operacionesCorte.controller';

const OperacionesCorteComponent = {
  controller,
  template
};

export default OperacionesCorteComponent;



// WEBPACK FOOTER //
// ./src/app/components/operaciones/corteAnual/operacionesCorte.component.js